import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  NgbAccordionBody,
  NgbAccordionButton,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader,
  NgbAccordionItem,
} from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, Observable, Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../shared/anet/auth/auth.service';
import { AthleticUser } from '../../shared/anet/models/athletic-user.interface';
import { LocaleToggleComponent } from '../../shared/locale-toggle/locale-toggle.component';
import { SiteConfigInterface } from '../../shared/models/config/site-config.interface';
import { IsDarkModeService } from '../../shared/services/is-dark-mode.service';
import { IsDesktopService } from '../../shared/services/is-desktop.service';
import { IsSidebarOpenService } from '../../shared/services/is-sidebar-open.service';
import { SiteConfigService } from '../../shared/services/site-config.service';
import { AboutComponent } from 'src/app/page/about/about.component';
import { ResultsComponent } from 'src/app/individual-event/results/results.component';

@Component({
  selector: 'app-main-sidebar',
  imports: [
    AsyncPipe,
    FontAwesomeModule,
    RouterLink,
    RouterLinkActive,
    NgbAccordionBody,
    NgbAccordionButton,
    NgbAccordionCollapse,
    NgbAccordionDirective,
    NgbAccordionHeader,
    NgbAccordionItem,
    NgOptimizedImage,
    LocaleToggleComponent,
    AboutComponent,
    ResultsComponent,
  ],
  templateUrl: './main-sidebar.component.html',
  styleUrls: ['./main-sidebar.component.scss'],
})
export class MainSidebarComponent {
  @ViewChild('mainSideMenu') mainSideMenu!: ElementRef;
  @ViewChild('backgroundCurtain') backgroundCurtain!: ElementRef;
  isSidebarOpenServiceSubscription!: Subscription;
  isDarkMode$!: Observable<boolean>;
  desktop$!: Observable<boolean>;
  siteConfig$!: Observable<SiteConfigInterface | null>;
  userRoles: string[] = [];

  constructor(
    public route: ActivatedRoute,
    public isSidebarOpenService: IsSidebarOpenService,
    public isDesktopService: IsDesktopService,
    private isDarkModeService: IsDarkModeService,
    public siteConfigService: SiteConfigService,
    public authService: AuthService,
  ) {
    this.isDarkMode$ = this.isDarkModeService.isDarkMode;
    this.desktop$ = this.isDesktopService.isDesktop;
    this.siteConfig$ = this.siteConfigService.updateSiteConfig;

    this.isSidebarOpenServiceSubscription = this.isSidebarOpenService.isSidebarOpen.subscribe((isSidebarOpen) => {
      if (this.mainSideMenu) {
        if (isSidebarOpen) {
          this.mainSideMenu.nativeElement.classList.add('main-side-menu--open');
        } else {
          this.mainSideMenu.nativeElement.classList.remove('main-side-menu--open');
        }
      }
      if (this.backgroundCurtain) {
        if (isSidebarOpen) {
          this.backgroundCurtain.nativeElement.classList.add('open');
        } else {
          this.backgroundCurtain.nativeElement.classList.remove('open');
        }
      }
    });

    this.authService.updateUser.subscribe(async (user: AthleticUser | null) => {
      if (user?.userId) {
        this.userRoles = await this.authService.getMyRoles();
      }
    });
  }

  async ngOnInit() {
    const desktopFirstLoad = await firstValueFrom(this.isDesktopService.isDesktop);
    if (desktopFirstLoad) {
      if (this.mainSideMenu) {
        this.mainSideMenu.nativeElement.classList.add('main-side-menu--open');
      }
    }
  }

  onDarkModeToggle() {
    this.isDarkModeService.toggleDarkMode();
  }

  async ngOnDestroy() {
    if (this.isSidebarOpenServiceSubscription) {
      this.isSidebarOpenServiceSubscription.unsubscribe();
    }
  }

  protected readonly environment = environment;
}
